import styled from "styled-components";

export const StyledWalletHistoryTitleContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral200};
  padding-bottom: 16px;
`;
